var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandable-preview relative-position",class:_vm.classes,staticStyle:{"overflow":"auto"}},[_c('div',{style:(_vm.style),attrs:{"not-v-mutation":"contentChanged"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }